// Save session token key
export const SESSION_KEY = '@session';

// Save select space key
export const SELECT_SPACE_KEY = '@select-space';
